import type { Dimension, DateDimension, Attribute, DataSourceInfo } from '@sisense/sdk-data';

import { createAttribute, createDateDimension, createDimension } from '@sisense/sdk-data';

const dataSourceName = process.env.NODE_ENV === 'production' ? 'BC_CALL_FB_PRODUCTION_DATA_SOURCE_V_0_0_1' : 'BC_CALL_FB_STAGING_DATA_SOURCE_V_0_0_1';

export const DataSource: DataSourceInfo = {
  title: dataSourceName,
  type: 'live',
};

interface CallResultDimension extends Dimension {
  call_result_type_id: Attribute;
  call_result_type_name: Attribute;
  connected_text: Attribute;
  connected_to_text: Attribute;
  created_by: Attribute;
  default_call_result_type_id: Attribute;
  CallResult_id: Attribute;
  first_set_up_at_jst: DateDimension;
}
export const CallResult = createDimension({
  name: 'CallResult',
  call_result_type_id: createAttribute({
    name: 'call_result_type_id',
    type: 'numeric-attribute',
    expression: '[CallResult.call_result_type_id]',
    dataSource: { title: dataSourceName, live: true },
  }),
  call_result_type_name: createAttribute({
    name: 'call_result_type_name',
    type: 'text-attribute',
    expression: '[CallResult.call_result_type_name]',
    dataSource: { title: dataSourceName, live: true },
  }),
  connected_text: createAttribute({
    name: 'connected_text',
    type: 'text-attribute',
    expression: '[CallResult.connected_text]',
    dataSource: { title: dataSourceName, live: true },
  }),
  connected_to_text: createAttribute({
    name: 'connected_to_text',
    type: 'text-attribute',
    expression: '[CallResult.connected_to_text]',
    dataSource: { title: dataSourceName, live: true },
  }),
  created_by: createAttribute({
    name: 'created_by',
    type: 'text-attribute',
    expression: '[CallResult.created_by]',
    dataSource: { title: dataSourceName, live: true },
  }),
  default_call_result_type_id: createAttribute({
    name: 'default_call_result_type_id',
    type: 'numeric-attribute',
    expression: '[CallResult.default_call_result_type_id]',
    dataSource: { title: dataSourceName, live: true },
  }),
  CallResult_id: createAttribute({
    name: '[CallResult.id]',
    type: 'numeric-attribute',
    expression: '[CallResult.id]',
    dataSource: { title: dataSourceName, live: true },
  }),
  first_set_up_at_jst: createDateDimension({
    name: 'first_set_up_at_jst',
    expression: '[CallResult.first_set_up_at_jst (Calendar)]',
    dataSource: { title: dataSourceName, live: true },
  }),
}) as CallResultDimension;

interface QualitativeFeedbackResultDimension extends Dimension {
  closing_count: Attribute;
  question_count: Attribute;
}
export const QualitativeFeedbackResult = createDimension({
  name: 'QualitativeFeedbackResult',
  closing_count: createAttribute({
    name: 'closing_count',
    type: 'numeric-attribute',
    expression: '[QualitativeFeedbackResult.closing_count]',
    dataSource: { title: dataSourceName, live: true },
  }),
  question_count: createAttribute({
    name: 'question_count',
    type: 'numeric-attribute',
    expression: '[QualitativeFeedbackResult.question_count]',
    dataSource: { title: dataSourceName, live: true },
  }),
}) as QualitativeFeedbackResultDimension;

export const Tenant = createDimension({
  name: 'Tenant',
  Tenant_id: createAttribute({
    name: '[Tenant.id]',
    type: 'numeric-attribute',
    expression: '[Tenant.id]',
    dataSource: { title: dataSourceName, live: true },
  }),
});

interface TranscriptionSpeakerMetricDimension extends Dimension {
  mora_per_second: Attribute;
  speaker_type_text: Attribute;
  talk_ratio: Attribute;
  total_talk_seconds: Attribute;
}
export const TranscriptionSpeakerMetric = createDimension({
  name: 'TranscriptionSpeakerMetric',
  mora_per_second: createAttribute({
    name: 'mora_per_second',
    type: 'numeric-attribute',
    expression: '[TranscriptionSpeakerMetric.mora_per_second]',
    dataSource: { title: dataSourceName, live: true },
  }),
  speaker_type_text: createAttribute({
    name: 'speaker_type_text',
    type: 'text-attribute',
    expression: '[TranscriptionSpeakerMetric.speaker_type_text]',
    dataSource: { title: dataSourceName, live: true },
  }),
  talk_ratio: createAttribute({
    name: 'talk_ratio',
    type: 'numeric-attribute',
    expression: '[TranscriptionSpeakerMetric.talk_ratio]',
    dataSource: { title: dataSourceName, live: true },
  }),
  total_talk_seconds: createAttribute({
    name: 'total_talk_seconds',
    type: 'numeric-attribute',
    expression: '[TranscriptionSpeakerMetric.total_talk_seconds]',
    dataSource: { title: dataSourceName, live: true },
  }),
}) as TranscriptionSpeakerMetricDimension;
